import React from "react";
import { useT } from "@/context/LanguageContext";

export default function Footer({ contact, logoUrl }) {
  const { t, ui } = useT();
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[color:var(--gcs-emerald)] text-[color:var(--gcs-ivory)] with-grain" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src={logoUrl} alt="Logo" className="h-14 w-14 object-contain rounded-sm bg-[color:var(--gcs-ivory)] p-1.5" />
              <div>
                <div className="font-serif text-xl">General Cleaning Services, LLC</div>
                <div className="overline text-[color:var(--gcs-gold)]">est. by Maria Solis</div>
              </div>
            </div>
            <p className="text-[color:var(--gcs-ivory)]/70 text-sm max-w-md leading-relaxed">
              {t(contact?.tagline)}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-[color:var(--gcs-gold)] mb-4">{ui("footer.contact")}</p>
            <ul className="space-y-2 text-sm text-[color:var(--gcs-ivory)]/80">
              <li>
                <a className="gcs-underline" href={`tel:${contact?.phone}`} data-testid="footer-phone">{contact?.phone}</a>
              </li>
              <li>
                <a className="gcs-underline break-all" href={`mailto:${contact?.email}`} data-testid="footer-email">{contact?.email}</a>
              </li>
              <li>{t(contact?.service_area)}</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-[color:var(--gcs-gold)] mb-4">{ui("footer.explore")}</p>
            <ul className="grid grid-cols-2 gap-y-2 text-sm text-[color:var(--gcs-ivory)]/80">
              <li><a href="#servicios" className="gcs-underline">{ui("nav.services")}</a></li>
              <li><a href="#precios" className="gcs-underline">{ui("nav.pricing")}</a></li>
              <li><a href="#manifiesto" className="gcs-underline">{ui("nav.manifesto")}</a></li>
              <li><a href="#galeria" className="gcs-underline">{ui("nav.gallery")}</a></li>
              <li><a href="#contacto" className="gcs-underline">{ui("cta.book")}</a></li>
              <li>
                <a href="/admin/login" className="gcs-underline" data-testid="footer-admin-link">
                  {ui("footer.admin")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[color:var(--gcs-line-dark)] flex flex-col md:flex-row justify-between gap-3 text-xs text-[color:var(--gcs-ivory)]/50">
          <span>© {year} General Cleaning Services, LLC. {ui("footer.rights")}</span>
          <span className="overline text-[color:var(--gcs-gold)]">{ui("footer.tagline_line")}</span>
        </div>
      </div>
    </footer>
  );
}
